<template>
    <div>
        <div class="form" v-if="$route.path == '/SendGoods/SendGoodsForHXView'">
            <el-form style="margin:20px;width:70%;min-width:600px;" label-width="180px">
                <el-form-item class='edit-form' label="销售下单号">
                    <span>{{Form.OrderCode}}</span>
                    <el-button @click="printSendGooods" style="margin-left: 350px" v-show="Form.IsViewPrint">打印发货通知单</el-button>
                </el-form-item>
                <el-form-item class='edit-form' label="发货通知单号">
                    <span>{{Form.SendCode}}</span>
                </el-form-item>
                <!--<el-form-item class='edit-form' label="发货通知单状态">-->
                <!--<span>{{Form.SendStatusName}}</span>-->
                <!--</el-form-item>-->
                <el-form-item class='edit-form' label="代理商" style="width:100%;">
                    <!--<span>{{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>-->
                    <span>{{Form.AgentCode}} &nbsp; {{Form.AgentName}} &nbsp; {{Form.AgentAddress}} &nbsp; {{Form.AgentTel}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="下单对象">
                    <span>{{Form.ObjectName}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="发货通知单下单时间" v-show="false">
                    <span>{{Form.SendTime}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="发货通知单下单人" v-show="false">
                    <span>{{Form.AddUserName}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="发货情况">
                    <span>{{Form.DeliveryStatusName}}</span>
                </el-form-item>

                <div v-show="Form.ProjectType==2">

                    <el-form-item class='edit-form' label="Hi幼教样机数量">
                        <span>{{Form.ProtoTypeNum}}</span>
                    </el-form-item>

                    <el-form-item class='edit-form' label="样机已抵扣数">
                        <span>{{Form.ProtoTypeDeductibleNum}}</span>
                    </el-form-item>

                    <el-form-item class='edit-form' label="此单需抵扣数">
                        <span>{{Form.OrderProtoTypeDeductibleNum}}</span>
                    </el-form-item>

                </div>

                <el-form-item class='edit-form' label="套餐名称" v-show="Form.PackageName!=''">
                    <span>{{Form.PackageName}}</span>
                </el-form-item>
                <el-form-item label="经销商库存发货情况" v-show="Form.AgentOutNum >0">

                    <el-table :data="Form.AgentOutList" border style="width:80%;  ">
                        <el-table-column label="使用库存" align="center">
                            <el-table-column prop="AgentName" label="代理商名字" align="center">
                            </el-table-column>
                            <el-table-column prop="C_Name" label="主联系人" align="center">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="使用数量" align="center">
                            <template scope="scope">
                                {{Form.AgentOutNum}}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item class='edit-form' label="商品" v-show="Form.ListGoods!=''" style="width:900px">
                    <el-table :data="Form.ListGoods" border style="width: 80%;  ">
                        <el-table-column prop="ProName" label="名称">
                        </el-table-column>
                        <el-table-column label="包含单品" width="240">
                            <template scope="scope">
                                <div v-if="scope.row.PackDetail.length==0">--</div>
                                <div v-else class="dpDvCtnCss">
                                    <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ProductNum" label="订单数">
                        </el-table-column>
                        <!--<el-table-column prop="UnSendNum" label="未通知数">-->
                        <!--</el-table-column>-->
                        <el-table-column prop="SendNum" label="通知数">
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item class='edit-form' label="赠品" v-show="Form.GiftGoods!=''" style="width:900px">
                    <el-table :data="Form.GiftGoods" border style="width: 80%;  ">
                        <el-table-column prop="ProName" label="名称">
                        </el-table-column>
                        <el-table-column label="包含单品" width="240">
                            <template scope="scope">
                                <div v-if="scope.row.PackDetail.length==0">--</div>
                                <div v-else class="dpDvCtnCss">
                                    <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ProductNum" label="订单数">
                        </el-table-column>
                        <!--<el-table-column prop="UnSendNum" label="未通知数">-->
                        <!--</el-table-column>-->
                        <el-table-column prop="SendNum" label="通知数">
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <!--<el-form-item class='edit-form' label="要求发货时间">-->
                <!--<span>{{Form.RequireSendDate}}</span>-->
                <!--</el-form-item>-->
                <!--<el-form-item class='edit-form' label="发货通知单审核时间">-->
                <!--<span>{{Form.AuditTime}}</span>-->
                <!--</el-form-item>-->
                <el-form-item label="租用申请表" v-show="Form.ApplyPic.length>0">
                    <div class="show-img-ctn uclear">
                        <template v-for="(item,index) in Form.ApplyPic">
                            <div class="show-img-cell" @click="LookPicture(item.Url)">
                                <img :alt="item.Name" :src="item.Url" />
                            </div>
                        </template>
                    </div>
                </el-form-item>
                <el-form-item class='edit-form' label="收货地址" style="width:600px;">
                    <span>{{Form.AgentConsignee}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="收货人及联系方式">
                    <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
                </el-form-item>
                <el-form-item class='edit-form w100' label="订单备注">
                    <span>{{Form.OrderRemark}}</span>
                </el-form-item>
                <el-form-item class='edit-form w100' label="财务审核备注">
                    <span>{{Form.AuditRemark}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="寄送方式">
                    <span>{{Form.SendModeName}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="支付方式">
                    <span>{{Form.PayModeName}}</span>
                </el-form-item>
                <el-row>
                    <el-col :span="24" style="display: flex;justify-content: center;margin-bottom: 15px">
                        <el-button @click="viewSure">我知道了</el-button>
                    </el-col>
                </el-row>
                <el-dialog v-model="PictureVisible" size="small">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
        </div>
        <div v-else>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import NProgress from "nprogress";
import {
  ViewSendGoodsForStock,
  ViewSendGoodsForThird
} from "@api/sendGoodsApi.js";
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";
module.exports = {
  data() {
    return {
      PictureVisible: false,
      dialogImageUrl: "",
      Form: {
        ApplyPic: []
      }
    };
  },
  computed: {
    isShowIsFirst() {
      if (this.Form.IsFirst > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    LookPicture(Url) {
      this.dialogImageUrl = Url;
      this.PictureVisible = true;
    },
    viewSure() {
      window.history.go(-1);
    },
    printSendGooods() {
      util.redirect(
        this,
        "/SendGoods/SendGoodsForHXView/SendGoodsForHXPage?Id=" +
          this.$route.query.Id,
        false
      );
    }
  },
  created: function() {
    if (
      this.$route.query.Id != undefined &&
      this.$route.query.Sid != undefined &&
      this.$route.query.Session != undefined
    ) {
      let _session = util.getSessin();
      let para = {
        Sid: _session[0],
        Session: _session[1],
        Id: this.$route.query.Id
      };
      ViewSendGoodsForThird(para).then(res => {
        util.doResult(this, res, () => {
          let Data = res.data.Data;
          this.Form = [];
          this.Form = Data;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dpDvCss {
  border-bottom: 1px solid #ccc;
  line-height: 34px;
}

.dpDvCtnCss .dpDvCss:last-child {
  border: 0px !important;
}
</style> 


// WEBPACK FOOTER //
// SendGoodsForHXView.vue?3bc0203c